import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { authEnabled, signUp, translateCognitoError } from '../../auth/auth';
import { sanitizeReturnTo, withReturnTo } from '../../lib/returnTo';

export default function SignUp() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // 認証未設定（モックモード）ではこの画面自体を表示しない。
  if (!authEnabled) return <Navigate to="/" replace />;

  // ログイン画面から引き継いだ復帰先。メール確認画面（/verify）へさらに引き継ぐ。
  const from = sanitizeReturnTo(searchParams.get('from'));

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await signUp(email, password);
      navigate(withReturnTo(`/verify?email=${encodeURIComponent(email)}`, from));
    } catch (err) {
      setError(translateCognitoError(err));
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">新規登録</h1>
        <p className="auth-card__lead">VRMA Hub のアカウントを作成します。</p>

        <form className="auth-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="email">メールアドレス</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="password">パスワード</label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="auth-form__hint">8 文字以上で入力してください。</div>
          </div>

          {error && <div className="auth-form__error">{error}</div>}

          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? '処理中…' : 'アカウントを作成'}
          </button>
        </form>

        <div className="auth-form__links">
          <Link to={withReturnTo('/login', from)}>既にアカウントをお持ちの場合は ログイン</Link>
        </div>
      </div>
    </div>
  );
}
